/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Service from '../service';
import { toast } from 'react-toastify';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Pagination from 'components/Pagination';
import { useHistory } from 'react-router-dom';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';

import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  Input,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';

import SimpleHeader from '../../../components/Headers/SimpleHeader';
import ReactLoader from 'components/Loader';
import ListModal from './components/ListModal';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';

const ListBlackList = () => {
  const history = useHistory();

  const [blackLists, setBlackLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [idBlackList, setidBlackList] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [isListModalOpen, setIsListModalOpen] = useState(false);

  useEffect(() => {
    handleGetResource();
  }, []);

  const handleGetResource = (selectedPage = 1, querySearch = '') => {
    Service.getAllSeach(selectedPage, 10, querySearch, false)
      .then((res) => {
        const { data, totalRegisters } = res.data;
        const newActivePage = selectedPage || activePage;

        setBlackLists(data);
        setQuantity(totalRegisters);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch(() => {
        toast.error('Não foi possível listar as listas de bloqueio', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handlePageChange = (activePage) => handleGetResource(activePage);

  const handleDelete = (id) => {
    Service.delete(id)
      .then(() => {
        toast.success('Lista de bloqueio deletada com sucesso', {
          autoClose: 3000,
          closeOnClick: true
        });
        handleGetResource();
      })
      .catch((err) => {
        console.log(err.response);
        toast.error('Ocorreu um erro!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        handleGetResource();
      });
  };

  const controlDeleteBlackList = (idBlackList) => {
    setidBlackList(idBlackList);
    setOpenModalConfirmation(true);
  };

  const handleUpdate = (id) => {
    history.push(`blackList/form/${id}`);
  };

  const handleOnSearch = (event) => {
    const q = event.target.value;
    setTimeout(() => {
      handleGetResource(1, q);
    }, 500);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/blackList/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Lista de bloqueio</h3>
                </CardHeader>

                <Row className="mt-3 mx-2">
                  <Col md="11">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="fas fa-search" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        placeholder="Busca Lista de bloqueio"
                        type="text"
                        defaultValue=""
                        onChange={handleOnSearch}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <ToolkitProvider
                  data={blackLists}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'name',
                      text: 'Nome',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'ddr.ddr',
                      text: 'DDR',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: `blocked`,
                      text: `Bloquear para todas DDR's`,
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (blocked) => {
                        return blocked ? 'Sim' : 'Não';
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            color="info"
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-user-edit"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'list',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Lista',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            onClick={() => {
                              setidBlackList(row.id);
                              setIsListModalOpen(true);
                            }}
                          >
                            <li className="fas fa-list" />
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      // eslint-disable-next-line react/display-name
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => controlDeleteBlackList(row.id)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idBlackList}
        deleteResource={handleDelete}
        message={'Tem certeza que deseja excluir a lista de bloqueio?'}
      />
      <ListModal
        isModalOpen={isListModalOpen}
        onModalToggle={setIsListModalOpen}
        unmountOnClose={true}
        blacklistId={idBlackList}
      />
    </>
  );
};

export default ListBlackList;
